import {View} from 'react-native';
import _ from 'lodash';

import Format from '~/lib/format';

import sy from '~/styles';
import {Text} from '~/components/controls';

export default ({style, location, widths}) => {
  return (
    <>
      <View style={style}>
        <View
          style={{
            width: 24,
            height: 24,
            backgroundColor: '#f2f2f2',
            borderRadius: 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Text style={sy.xSmallMedium}>
            {_.isNumber(widths?.[location]) ? (
              Format.number(widths?.[location], 1, false)
            ) : (
              <>?</>
            )}
          </Text>
        </View>
      </View>
    </>
  );
};
